module.exports = __webpack_public_path__ + "img/151.0a329bd8.png";